import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './BrandLogo.module.css';

function toCssSize(value) {
  if (value == null || value === '') return undefined;
  return typeof value === 'number' ? `${value}px` : String(value);
}

const BrandLogo = ({
  alt = 'Richuel',
  decorative,
  to,
  className,
  imgClassName,
  src = '/logo.gif',
  size,
  radius,
  style,
  ...imgProps
}) => {
  const navigate = useNavigate();

  const isClickable = Boolean(to);
  const handleNavigate = useCallback(() => {
    if (!to) return;
    navigate(to);
  }, [navigate, to]);

  const handleKeyDown = useCallback((event) => {
    if (!to) return;
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      navigate(to);
    }
  }, [navigate, to]);

  const containerProps = (() => {
    if (isClickable) {
      return {
        role: 'link',
        tabIndex: 0,
        onClick: handleNavigate,
        onKeyDown: handleKeyDown,
        'aria-label': alt,
        'data-clickable': 'true',
      };
    }

    if (decorative) return { 'aria-hidden': true };
    return {};
  })();

  const sizeCss = toCssSize(size);
  const radiusCss = toCssSize(radius);
  const mergedStyle = {
    ...(style || {}),
    ...(sizeCss ? { '--brand-logo-size': sizeCss } : null),
    ...(radiusCss ? { '--brand-logo-radius': radiusCss } : null),
  };

  return (
    <div
      className={[styles['logo-container'], className].filter(Boolean).join(' ')}
      style={mergedStyle}
      {...containerProps}
    >
      <img
        src={src}
        alt={decorative ? '' : alt}
        className={[styles['brand-logo'], imgClassName].filter(Boolean).join(' ')}
        width={typeof size === 'number' ? size : undefined}
        height={typeof size === 'number' ? size : undefined}
        {...imgProps}
      />
    </div>
  );
};

export default BrandLogo;
